// src/components/analytics/components/CustomTooltip.js
import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <Paper
                elevation={3}
                sx={{
                    background: 'rgba(255, 255, 255, 0.95)',
                    p: 2,
                    border: '1px solid #f0f0f0',
                    borderRadius: 1
                }}
            >
                <Typography variant="subtitle2" sx={{ mb: 1 }}>{label}</Typography>
                {payload.map((entry, index) => (
                    <Box key={`tooltip-item-${index}`} sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <Box
                            component="span"
                            sx={{
                                width: 12,
                                height: 12,
                                borderRadius: '50%',
                                bgcolor: entry.color,
                                mr: 1
                            }}
                        />
                        <Typography variant="body2" color="text.secondary">
                            {entry.name}: <b>{
                            typeof entry.value === 'number' &&
                            !entry.name.includes('Margin') &&
                            !entry.name.includes('Rate')
                                ? entry.value.toLocaleString('en-KE', { style: 'currency', currency: 'KES' })
                                : entry.name.includes('Margin') || entry.name.includes('Rate')
                                    ? `${entry.value}%`
                                    : entry.value
                        }</b>
                        </Typography>
                    </Box>
                ))}
            </Paper>
        );
    }
    return null;
};

export default CustomTooltip;